import { Injectable } from '@angular/core';
import { SupabaseService } from './base/supabase.service';

@Injectable({
  providedIn: 'root',
})
export class DeferCaseActionService {
  constructor(private supabaseService: SupabaseService) {}

  async defer(caseActionId: string, userId: string, claimId: string): Promise<void> {
    await this.supabaseService.callLambda('defer-case-action', 'POST', {
      case_action_id: caseActionId,
      user_id: userId,
      claim_id: claimId,
    });
  }
}
